import { EventDetailsDto } from "@merchant_api/models/event-details-dto";

export class EventState {
    loading = false;
    error = null;
    record: EventDetailsDto = null;
}
